import { Box, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

function Clientslist({ result, clearSearch }) {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "2px",
        marginTop: "5px",
      }}
    >
      <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
        Clients {result.clients?.length > 0 && `(${result.clients.length})`}
      </Typography>
      <Box
        sx={{
          marginTop: "5px",
          display: "flex",
          flexDirection: "column",
          gap: "6px",
        }}
      >
        {result.clients?.length > 0 ? (
          result.clients.map((obj, i) => {
            return (
              <Box
                key={i}
                onClick={() => {
                  navigate(`/client-detail`, {
                    state: { selectedClient: obj },
                  });
                  clearSearch();
                }}
                sx={{
                  width: "100%",
                  padding: "10px",
                  backgroundColor: "#673C8E0F",
                  fontWeight: 700,
                  color: "black",
                  "&:active": {
                    backgroundColor: "#ddd0e9", // new background on hover
                  },
                }}
              >
                {obj.customerID}
              </Box>
            );
          })
        ) : (
          <Typography
            sx={{ fontWeight: 700, fontSize: "14px", color: "black" }}
          >
            No Results
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default Clientslist;
